/**
 * MLS Listing types
 */
// A listing counts as "New" for this many days after its list date - one
// shared threshold so the map badges, drawer badges, and New section
// filter/sort can't drift out of sync with each other.
export const NEW_LISTING_DAYS = 7;
export function isNewListing(listing) {
    if (!listing.listDate)
        return false;
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - NEW_LISTING_DAYS);
    return new Date(listing.listDate) >= cutoff;
}
// True only for a listing whose list date is today - distinguishes "came
// up today" from "new this week" in the New section. listDate is a plain
// date (no time-of-day), so it parses as UTC midnight; reading it back via
// the UTC accessors returns exactly those calendar digits regardless of
// the browser's timezone, which is then compared against the viewer's own
// local calendar day.
export function isListedToday(listing) {
    if (!listing.listDate)
        return false;
    const listDate = new Date(listing.listDate);
    const now = new Date();
    return listDate.getUTCFullYear() === now.getFullYear()
        && listDate.getUTCMonth() === now.getMonth()
        && listDate.getUTCDate() === now.getDate();
}
// Favorite/alert keys are always tmkNormalized when available - matches
// PropertyModal.onAlertToggle, the Listings Drawer's bell, and
// toggleFavorite's own resolution (utils/alerts.ts, utils/favorites.ts
// both key anonymous/server rows by tmk, falling back to the internal
// mls_listings id only when tmkNormalized is genuinely unavailable).
// Checking listing.id unconditionally silently never matches a tmk-keyed
// favorite/alert - this exact bug has recurred more than once across the
// map badges, the drawer, and the CNTL attribute filter, hence one shared
// helper instead of every call site re-deriving the same fallback.
export function listingItemKey(listing) {
    return listing.tmkNormalized || listing.id;
}
//# sourceMappingURL=listing.js.map